// extracted by mini-css-extract-plugin
export default {"view":"MessageList_view__lqAwy"};